import { useChildCheckinDetailQuery } from '@famly/stat_kinder-connect-capture_data';
// The generated GraphQL type marks every field optional-and-nullable (`?: T | null`); normalize
// to always-present-but-nullable so consumers don't have to juggle `undefined` on top of `null`.
const adaptCapture = (capture) => {
    var _a, _b, _c, _d;
    return ({
        photoUrl: (_a = capture.photoUrl) !== null && _a !== void 0 ? _a : null,
        signatureUrl: (_b = capture.signatureUrl) !== null && _b !== void 0 ? _b : null,
        latitude: (_c = capture.latitude) !== null && _c !== void 0 ? _c : null,
        longitude: (_d = capture.longitude) !== null && _d !== void 0 ? _d : null,
    });
};
/**
 * Fetches and adapts the KinderConnect capture data stored for a single check-in, for display in
 * `KinderConnectCaptureDetailDrawer`. Skips the fetch until `options.skip` is false (e.g. only
 * once the drawer showing this data is actually open).
 *
 * @param childCheckinId - The check-in to fetch capture data for.
 * @param options - `skip` to defer fetching (e.g. until the consuming drawer opens).
 * @returns The available capture entries plus `loading`/`error` state.
 */
export const useKinderConnectCaptureDetail = (childCheckinId, options) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const query = useChildCheckinDetailQuery({
        variables: { childCheckinId },
        skip: !childCheckinId || Boolean(options === null || options === void 0 ? void 0 : options.skip),
    });
    const checkin = (_a = query.data) === null || _a === void 0 ? void 0 : _a.attendance.childCheckins.byId;
    const media = checkin === null || checkin === void 0 ? void 0 : checkin.kinderConnectMedia;
    const captures = [];
    if (media === null || media === void 0 ? void 0 : media.atCheckin) {
        // Never stands for pickup too: the export never sends a check-in capture for pickup. No "missing"
        // card either, since in a day of room moves only the last row needs a pickup capture.
        captures.push({
            direction: 'checkin',
            personName: (_c = (_b = checkin === null || checkin === void 0 ? void 0 : checkin.checkedInBy) === null || _b === void 0 ? void 0 : _b.name.fullName) !== null && _c !== void 0 ? _c : null,
            time: (_d = checkin === null || checkin === void 0 ? void 0 : checkin.checkinTime) !== null && _d !== void 0 ? _d : null,
            capture: adaptCapture(media.atCheckin),
        });
    }
    if (media === null || media === void 0 ? void 0 : media.atCheckout) {
        captures.push({
            direction: 'checkout',
            personName: (_f = (_e = checkin === null || checkin === void 0 ? void 0 : checkin.checkedOutBy) === null || _e === void 0 ? void 0 : _e.name.fullName) !== null && _f !== void 0 ? _f : null,
            time: (_g = checkin === null || checkin === void 0 ? void 0 : checkin.checkoutTime) !== null && _g !== void 0 ? _g : null,
            capture: adaptCapture(media.atCheckout),
        });
    }
    return {
        captures,
        loading: query.loading,
        error: Boolean(query.error),
    };
};
